import { Dropdown } from '~/components2/Dropdown';
import Icon from '~/components2/Icon';
import { handleUtilityPresetToggle } from './handlers';

interface SectionCommandsProps {
  title: string;
  /** Leaves the picker is currently hiding; the "on" presets must not turn these on. */
  pickerHiddenLeafIds?: ReadonlySet<string>;
}

export default function SectionCommands({ title, pickerHiddenLeafIds }: SectionCommandsProps) {
  if (title === 'Utilities') {
    return (
      <Dropdown
        side="right"
        align="start"
        data-testid="utilities-preset-menu-trigger"
        triggerElement={
          <button
            type="button"
            aria-label="Utility layer presets"
            className="flex cursor-pointer appearance-none items-center justify-center rounded border-0 bg-transparent p-1 hover:bg-grey-20"
          >
            <Icon icon="lightning" />
          </button>
        }
        items={[
          {
            type: 'simple',
            label: <span data-testid="utilities-preset-lines-on">Toggle Utility Line Data On</span>,
            onClick: () => handleUtilityPresetToggle('utility_lines', 'on', pickerHiddenLeafIds),
          },
          {
            type: 'simple',
            label: <span data-testid="utilities-preset-lines-off">Toggle Utility Line Data Off</span>,
            onClick: () => handleUtilityPresetToggle('utility_lines', 'off'),
          },
          { type: 'separator' },
          {
            type: 'simple',
            label: <span data-testid="utilities-preset-points-on">Toggle Utility Points/Polygons On</span>,
            onClick: () => handleUtilityPresetToggle('utility_points_and_polygons', 'on', pickerHiddenLeafIds),
          },
          {
            type: 'simple',
            label: <span data-testid="utilities-preset-points-off">Toggle Utility Points/Polygons Off</span>,
            onClick: () => handleUtilityPresetToggle('utility_points_and_polygons', 'off'),
          },
          { type: 'separator' },

          {
            type: 'simple',
            label: <span data-testid="utilities-preset-services-on">Toggle Utility Services On</span>,
            onClick: () => handleUtilityPresetToggle('utility_services', 'on', pickerHiddenLeafIds),
          },
          {
            type: 'simple',
            label: <span data-testid="utilities-preset-services-off">Toggle Utility Services Off</span>,
            onClick: () => handleUtilityPresetToggle('utility_services', 'off'),
          },
        ]}
      />
    );
  }

  return null;
}
